(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jc-header"]) return;
  try {
    
  (function () {
    function setCartCount(header, count) {
      header.querySelectorAll('[data-jc-header-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('jc-header__cart-count--hidden', count === 0);
      });
    }

    function refreshFromServer(header) {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (data) {
          if (data && typeof data.item_count === 'number') setCartCount(header, data.item_count);
        })
        .catch(function () {});
    }

    document.addEventListener('DOMContentLoaded', function () {
      var header = document.querySelector('.jc-header');
      if (!header) return;

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event && event.cartData && typeof event.cartData.item_count === 'number') {
            setCartCount(header, event.cartData.item_count);
          } else {
            refreshFromServer(header);
          }
        });
      } else {
        window.addEventListener('pageshow', function () {
          refreshFromServer(header);
        });
      }

      var searchDisclosure = header.querySelector('.jc-header__mobile-search');
      if (!searchDisclosure) return;

      document.addEventListener('click', function (event) {
        if (searchDisclosure.open && !searchDisclosure.contains(event.target)) {
          searchDisclosure.removeAttribute('open');
        }
      });
      searchDisclosure.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') searchDisclosure.removeAttribute('open');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jc-math-module"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initJcMathModule(root) {
      if (!root || root.hasAttribute('data-jc-math-inited')) return;
      root.setAttribute('data-jc-math-inited', 'true');

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-jc-math-tab]'));
      var bars = root.querySelector('.jc-math__bars');
      var goldBar = root.querySelector('[data-jc-gold-bar]');
      var priceLabel = root.querySelector('[data-jc-price-label]');
      var priceValue = root.querySelector('[data-jc-price-value]');
      if (!tabs.length || !bars || !goldBar) return;

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t, i) {
            var selected = i === index;
            t.setAttribute('aria-selected', selected ? 'true' : 'false');
            t.setAttribute('tabindex', selected ? '0' : '-1');
          });
          goldBar.style.setProperty('--jc-w', (tab.dataset.fill || 0) + '%');
          if (priceLabel) priceLabel.textContent = tab.dataset.label || '';
          if (priceValue) priceValue.textContent = tab.dataset.price || '';
        });
      });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      bars.classList.add('jc-reveal-init');
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bars.classList.add('jc-reveal-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });
      observer.observe(root);
    }

    document.querySelectorAll('.jc-math').forEach(initJcMathModule);

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.jc-math');
      if (root) initJcMathModule(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jc-mobile-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setCartCount(nav, count) {
      nav.querySelectorAll('[data-jc-mobile-nav-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('jc-mobile-nav__cart-count--hidden', count === 0);
      });
    }

    function refreshFromServer(nav) {
      var url = nav.dataset.cartUrl || '/cart.js';
      fetch(url, { credentials: 'same-origin' })
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (data) {
          if (data && typeof data.item_count === 'number') setCartCount(nav, data.item_count);
        })
        .catch(function () {});
    }

    document.addEventListener('DOMContentLoaded', function () {
      var nav = document.querySelector('[data-jc-mobile-nav]');
      if (!nav) return;

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event && event.cartData && typeof event.cartData.item_count === 'number') {
            setCartCount(nav, event.cartData.item_count);
          } else {
            refreshFromServer(nav);
          }
        });
      } else {
        window.addEventListener('pageshow', function () {
          refreshFromServer(nav);
        });
      }

      var sheet = nav.querySelector('[data-jc-search-sheet]');
      var toggle = nav.querySelector('[data-jc-search-toggle]');
      var closeBtn = nav.querySelector('[data-jc-search-close]');
      var input = nav.querySelector('.jc-mobile-nav__search-input');
      if (!sheet || !toggle || !closeBtn) return;

      function setOpen(open) {
        sheet.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && input) input.focus();
      }

      toggle.addEventListener('click', function () {
        setOpen(!sheet.classList.contains('is-open'));
      });
      closeBtn.addEventListener('click', function () {
        setOpen(false);
      });
      nav.querySelectorAll('[data-jc-search-close-trigger]').forEach(function (el) {
        el.addEventListener('click', function () {
          setOpen(false);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
